// 权限项目常量
export default {
  ADMINISTRATOR: 'administrator',
  DASHBOARD: 'dashboard',
  // 超级权限，仅admin拥有,
  SUPER: 'super',

  // 客权限
  GUEST: 'guest',
  // 用户（非访客）权限
  USER: 'user',

  BI: 'bi_query',
  readRECORD: 'record_read',
  readKEY: 'key_read',

  queryDEPT: 'dept_query',
  editDEPT: 'dept_edit',
  addDEPT: 'dept_add',
  delDEPT: 'dept_del',
  binDEPT: 'dept_bin',

  queryUSER: 'user_query',
  editUSER: 'user_edit',
  addUSER: 'user_add',
  delUSER: 'user_del',
  impUSER: 'user_import',
  expUSER: 'user_export',
  fingerUSER: 'user_finger',

  queryWORKER: 'worker_query',
  editWORKER: 'worker_edit',
  addWORKER: 'worker_add',
  delWORKER: 'worker_del',
  fingerWORKER: 'worker_finger',
  impWORKER: 'worker_import',
  expWORKER: 'worker_export',

  queryROLE: 'role_query',
  editROLE: 'role_edit',
  addROLE: 'role_add',
  delROLE: 'role_del',

  queryKEY: 'key_query',
  editKEY: 'key_edit',
  addKEY: 'key_add',
  delKEY: 'key_del',
  initKEY: 'key_init',
  authKEY: 'key_auth',
  clearKey: 'key_clear',
  // outKEY: 'key_out',
  // inKEY: 'key_in',
  impKEY: 'key_import',
  expKEY: 'key_export',
  // auditKEY: 'keydata_audit',
  eventKEY: 'key_event',
  emergencyKEY: 'key_emergency',

  // 新增领出归还钥匙权限
  outKEY: 'key_usage_out',
  inKEY: 'key_usage_in',
  auditKEY: 'key_usage_audit',

  queryBLACKLIST: 'blacklist_query',
  addBLACKLIST: 'blacklist_add', // NOTE: 有歧义，其实是创建黑白钥匙
  delBLACKLIST: 'blacklist_del', // NOTE: 有歧义，其实是解除挂失
  expBLACKLIST: 'blacklist_export',

  queryLOCK: 'lock_query',
  editLOCK: 'lock_edit',
  addLOCK: 'lock_add',
  delLOCK: 'lock_del',
  initLOCK: 'lock_init',
  replaceLOCK: 'lock_replace',
  impLOCK: 'lock_import',
  expLOCK: 'lock_export',

  queryTASK: 'task_query',
  editTASK: 'task_edit',
  addTASK: 'task_add',
  delTASK: 'task_del',
  auditTASK: 'task_audit',
  downloadTASK: 'task_download',
  clearTASK: 'task_clear',
  expTASK: 'task_export',

  queryKEY_OUTIN: 'keydata_query',
  expKEY_OUTIN: 'keydata_export',

  queryTASK_DOWNLOAD: 'keytask_query',
  expTASK_DOWNLOAD: 'keytask_export',

  queryLOCK_SWITCH: 'lockdata_query',
  expLOCK_SWITCH: 'lockdata_export',

  queryKEY_LOST: 'keylostdata_query',
  expKEY_LOST: 'keylostdata_export',

  queryLOCK_REPLACE: 'lockreplace_query',
  expLOCK_REPLACE: 'lockreplace_export',

  queryLOG: 'log_query',
  expLOG: 'log_export',

  queryKEYBOX: 'keybox_query',
  editKEYBOX: 'keybox_edit',
  delKEYBOX: 'keybox_del',

  queryKEYBOXNODE: 'keyboxnode_query',
  takeoutKEYBOXNODE: 'keyboxnode_takeout',
  emergencyKEYBOXNODE: 'keyboxnode_emergency',
  ejectKEYBOXNODE: 'keyboxnode_eject',

  queryKEYBOX_DATA: 'keyboxdata_query',
  expKEYBOX_DATA: 'keyboxdata_export',

  queryKEYCABINET: 'keycabinet_query',
  editKEYCABINET: 'keycabinet_edit',
  delKEYCABINET: 'keycabinet_del',
  queryKEYCABINETNODE: 'keycabinetnode_query',
  loginKEYCABINET: 'keycabinet_login',

  queryELCCABINET: 'elc_cabinet_query',
  addELCCABINET: 'elc_cabinet_add',
  editELCCABINET: 'elc_cabinet_edit',
  delELCCABINET: 'elc_cabinet_del',
  bindELCCONTROLLER: 'elc_cabinet_controller_bind',
  bindELCLOCK: 'elc_cabinet_lock_bind',
  unlockELCLOCK: 'elc_cabinet_remote_unlock',

  queryELCCONTROLLER: 'elc_controller_query',
  addELCCONTROLLER: 'elc_controller_add',
  editELCCONTROLLER: 'elc_controller_edit',
  delELCCONTROLLER: 'elc_controller_del',
  debugELCCONTROLLER: 'elc_controller_debug',

  queryELCDOOR_SWITCH: 'elc_doordata_query',
  exportELCDOOR_SWITCH: 'elc_doordata_export',
  queryELCALARM_DATA: 'elc_alarmdata_query',
  exportELCALARM_DATA: 'elc_alarmdata_export',

  // 待更新任务
  queryTASKUPDATING: 'task_updating',
  // 远程下载
  downloadREMOTETASK: 'task_remote_download',
  // 钥匙盒孔管理
  keyboxnodeManage: 'keyboxnode_manage',

  queryLOCK_EVENTDATA: 'lockeventdata_query',
  exportLOCK_EVENTDATA: 'lockeventdata_export',
  readLOCK_EVENTDATA: 'lockeventdata_read',
  unlock_USER: 'user_resetlockstatus',
  revokeTask: 'task_revoke',
  copyTask: 'task_copy',
  setKeyParam: 'key_param',

  queryPATROL_SITE: 'patrol_site_query',
  addPATROL_SITE: 'patrol_site_add',
  editPATROL_SITE: 'patrol_site_edit',
  delPATROL_SITE: 'patrol_site_del',
  impPATROL_SITE: 'patrol_site_import',
  expPATROL_SITE: 'patrol_site_export',
  transferPATROL_SITE: 'patrol_site_transfer',

  queryPATROL_COLLECTED_SITE: 'patrol_collected_site_query',
  editPATROL_COLLECTED_SITE: 'patrol_collected_site_edit',
  delPATROL_COLLECTED_SITE: 'patrol_collected_site_del',

  queryPATROL_CONTENT: 'patrol_content_query',
  addPATROL_CONTENT: 'patrol_content_add',
  editPATROL_CONTENT: 'patrol_content_edit',
  delPATROL_CONTENT: 'patrol_content_del',
  bindPATROL_CONTENT: 'patrol_content_bind',

  queryPATROL_PLAN: 'patrol_plan_query',
  addPATROL_PLAN: 'patrol_plan_add',
  editPATROL_PLAN: 'patrol_plan_edit',
  delPATROL_PLAN: 'patrol_plan_del',
  dispatchPATROL_PLAN_KEY: 'patrol_plan_dispatch_key',
  claimPATROL_PLAN_KEY: 'patrol_plan_claim_key',

  queryPATROL_RECORD: 'patrol_record_query',
  uploadPATROL_RECORD: 'patrol_record_upload',

  queryPATROL_REPORT: 'patrol_report_query',
  expPATROL_REPORT: 'patrol_report_export',
};
